import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-change-real',
  templateUrl: './change-real.component.html',
  styleUrls: ['./change-real.component.css']
})
export class ChangeRealComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  customer_status;
  statusTo: string;
  changeStatus;
  customer_id;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     
      private customerService: CustomerService) { }

  ngOnInit() {
    console.log(this.data);
    this.customer_id = this.data.id;
    this.customer_status = this.data.prodAccount;
    if (this.customer_status === true) {
      this.statusTo = 'Test';
      this.changeStatus = 'false'
    } else {
      this.statusTo = 'Real';
      this.changeStatus = 'true'
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onDeleteConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.customerService.markCustomer(this.customer_id,this.changeStatus)
    .subscribe(
      data => {
        this.api_success = 'Updated Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
       this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }

}
